export const DEPOSIT_ROUTING = [
    {
        path: '/deposit',
        name: 'deposit',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Ký gửi', pathName: 'deposit', icon: 'fa fa-envelope' },
            ]
        },
        component: () => import('./Deposit.vue'),
        redirect: { name: 'deposit-index' },
        children: [
            { 
                path: '/ky-gui.html',
                name: 'deposit-index',
                component: () => import('./components/main-deposit/MainDeposit.vue')
            },
            {
                path: '/ky-gui/deposit-new.html',
                name: 'deposit-new',
                meta: {
                    breadcrumb: [
                        { name: 'Tạo mới ký gửi', pathName: 'deposit-new', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/add-new-deposit/AddNewDeposit.vue'),
            },
            {
                path: '/ky-gui/:id',
                name: 'deposit-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết ký gửi', pathName: 'deposit-detail', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/detail-deposit/DetailDeposit.vue'),
            },
            {
                path: '/khieu-nai-ky-gui/:orderId/:orderType',
                name: 'deposit-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại đơn ký gửi', pathName: 'deposit-complain', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('../order/components/complain-order/ComplainOrder.vue'),
            },
            {
                path: '/khieu-nai-ky-gui/:orderId/:complainId/:orderType',
                name: 'detail-deposit-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại đơn ký gửi', pathName: 'detail-deposit-complain', icon: 'fa fa-bar-chart' },
                    ]
                },
                component: () => import('../order/components/complain-order/ComplainOrder.vue')
            }
        ]
    }
];